import { ElementRef, Injectable, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { FncGroup } from '../../auth/FncGroup';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CurrentLoginUser } from '../../auth/CurrentLoginUser';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractFncGroupVisibilityDirective implements OnInit, OnDestroy {
  readonly destroy$: Subject<boolean> = new Subject<boolean>();

  protected constructor(
    private element: ElementRef,
    private fncGroups: FncGroup[],
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.authService
      .observeLoginState()
      .pipe(takeUntil(this.destroy$))
      .subscribe(loginState => {
        if (this.isInAnyGroup(loginState.user)) {
          this.element.nativeElement.style.visibility = 'visible';
        } else {
          this.element.nativeElement.style.visibility = 'hidden';
        }
      });
  }

  private isInAnyGroup(user: CurrentLoginUser) {
    for (const group of this.fncGroups) {
      if (user?.groupsSet?.has(group)) {
        return true;
      }
    }
    return false;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
